import { render, staticRenderFns } from "./v-table.vue?vue&type=template&id=507ffbd9&scoped=true&"
import script from "./v-table.vue?vue&type=script&lang=js&"
export * from "./v-table.vue?vue&type=script&lang=js&"
import style0 from "./v-table.vue?vue&type=style&index=0&id=507ffbd9&prod&scoped=true&lang=scss&"
import style1 from "./v-table.vue?vue&type=style&index=1&id=507ffbd9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507ffbd9",
  null
  
)

export default component.exports